import { Box, CircularProgress } from "@mui/material";
import type { FC } from "react";
import { SURFACE } from "@/theme/tokens";

type StaffingViewLoadingProps = { dataTestId: string };

/**
 * The waiting surface a Staffing view's route guard shows while its availability is still `"loading"`.
 * Fills the route slot exactly the way the views themselves do, so the header/grid does not jump when
 * the real view takes over.
 */
export const StaffingViewLoading: FC<StaffingViewLoadingProps> = ({ dataTestId }) => (
	<Box
		data-testid={dataTestId}
		sx={{
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			flex: 1,
			alignSelf: "stretch",
			width: "100%",
			minWidth: 0,
			height: "100%",
			backgroundColor: SURFACE,
		}}
	>
		<CircularProgress />
	</Box>
);
